import { messageColors } from './consts'

const baseStyle = {
  display: 'flex',
}

const defaultProps = {
  variant: 'info',
  size: 'md',
}

const sizes = {
  sm: {
    iconSize: 'xs',
    fontSize: 'sm',
  },
  md: {
    iconSize: 'sm',
    fontSize: 'md',
  },
}

const variants = {
  info: {
    color: messageColors.info,
  },
  warning: {
    color: messageColors.warning,
  },
  danger: {
    color: messageColors.danger,
  },
  success: {
    color: messageColors.success,
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
